module.exports = __webpack_public_path__ + "img/depa.7bebdf59.svg";